<template>
  <keep-alive>
    <component
      :is="state.component"
      v-if="state && state.component && state.status === 'success'"
      v-bind="{
        ...state.data,
        ...state.props,
        _index: props._index,
        staticData: state.staticData,
      }"
    />
  </keep-alive>
</template>

<script setup lang="ts">
import useDynamicComponentData from '~/composables/useDynamicComponentData';
import _Error from '~/components/content/_Error.vue';
import type {
  ICmsArticlesContent,
  ICmsDossiersContent,
  ICmsHomeSections,
} from '~~/types/_cms-types';

interface IProps {
  collection: string;
  item: number;
  m2aField: string;
  staticData?:
    | Record<string, unknown>
    | ICmsArticlesContent
    | ICmsHomeSections
    | ICmsDossiersContent;
  _index: number;
}

const props = defineProps<IProps>();
const state = ref<IDynamicComponentState | undefined>();

const checkForError = () => {
  if (state.value.status === 'error') {
    state.value.data = {
      name: 'Error',
      message: `Error loading ${props.collection} ${props.item}.`,
    };
    state.value.component = shallowRef(_Error);
    state.value.status = 'success';
  }
};

state.value = await useDynamicComponentData(
  props.collection,
  props.item,
  props.m2aField,
  props.staticData,
);
if (state.value) {
  checkForError();
}
</script>
